<template>
    <div class="container">
        <div class="list">
            <div v-for="geofence in allGeofences" 
                draggable
                @dragstart="handleDragStart($event, geofence)"
                @dragend="handleDragEnd($event, geofence)"
                :class="{ row: true, selected: value === geofence }"
                @click="$emit('input', geofence)">
                <img v-if="geofence.kind == 'fragment'" src="/icons/other/Fragment.svg">
                <img v-if="geofence.kind == 'regular'" src="/icons/other/Task.svg">
                {{ geofence.name }} <b v-if="geofence.kind == 'template'">(Template)</b>
            </div>
        </div>
        <div class="buttons">
            <ui-button @click="$refs.addModal.open()">Add</ui-button>

            <ui-modal ref="addModal" title="Add" @reveal="$refs.taskName.focus()">
                <div class="add-group">
                    <div class="icon">
                        <img src="/icons/other/Task.svg">
                    </div>
                    <div class="left">
                        <h1>Task</h1>
                        <p>Tasks actively monitor for events such as geofence crossings and send alerts based on these events.</p>
                    </div>
                    <div class="right">
                        <ui-textbox label="Task Name" ref="taskName" v-model="taskName"></ui-textbox>
                        <ui-button :disabled="taskName.length == 0" @click="handleCreateTask" color="primary">Create</ui-button>
                    </div>
                </div>

                <div class="add-group">
                    <div class="icon">
                        <img src="/icons/other/Fragment.svg">
                    </div>
                    <div class="left">
                        <h1>Fragment</h1>
                        <p>Fragments are reusable pieces of tasks that can be included into one or more tasks.</p>
                    </div>
                    <div class="right">
                        <ui-textbox label="Fragment Name" v-model="fragmentName"></ui-textbox>
                        <ui-button :disabled="fragmentName.length == 0" @click="handleCreateFragment" color="primary">Create</ui-button>
                    </div>
                </div>

                <div class="add-group">
                    <div class="icon">
                        <img src="/icons/other/Folder.svg">
                    </div>
                    <div class="left">
                        <h1>Folder</h1>
                        <p>Folders allow tasks and fragments to be organised for easier access. They do not affect how tasks are executed.</p>
                    </div>
                    <div class="right">
                        <ui-textbox label="Folder Name" v-model="folderName"></ui-textbox>
                        <ui-button :disabled="folderName.length == 0" @click="handleCreateFolder" color="primary">Create</ui-button>
                    </div>
                </div>
            </ui-modal>

            <ui-modal ref="addFolderModal" title="Add Folder">
                Adding folders isn't implemented in the prototype, but they would work much like Windows Explorer folders, allowing
                tasks and fragments to be dragged around the tree view so that users could (optionally) organise complex geofence
                sets as they want.
            </ui-modal>
        </div>
    </div>
</template>

<script>
import geofences from "@/geofences.js";

export default {
    data() {
        return {
            taskName: "",
            fragmentName: "",
            folderName: ""
        };
    },
    props: {
        value: { type: Object, required: true }
    },
    computed: {
        allGeofences() { return geofences.allGeofences; }
    },
    methods: {
        handleCreateTask() {
            geofences.addGeofence({ name: this.taskName, kind: "regular" });

            this.taskName = "";
            this.$refs.addModal.close();
        },
        handleCreateFragment() {
            geofences.addGeofence({ name: this.fragmentName, kind: "fragment" });

            this.fragmentName = "";
            this.$refs.addModal.close();
        },
        handleCreateFolder() {
            this.$refs.addModal.close();
            this.$refs.addFolderModal.open();
        },
        handleDragStart(e, geofence) {
            if (geofence.kind != 'fragment') {
                e.preventDefault();

                return;
            }

            e.dataTransfer.setData("fragment", geofence.id);
        },
        handleDragEnd(e, geofence) {
        }
    }
}
</script>

<style lang="less" scoped>
.container
{
    padding: 10px;
    display: flex;
    flex-direction: column;
}
.row
{
    padding: 5px;
    user-select: none;
    display: flex;
    flex-direction: row;
    align-items: center;

    & > img
    {
        margin-right: 4px;
    }
}
.selected
{
    background-color: #ddd;
}
.list
{
    flex-grow: 1;
}
.buttons
{
    flex-grow: 0;
}
.add-group
{
    border: 1px solid silver;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    padding: 8px 16px;
    padding-left: 8px;

    &:not(:last-child)
    {
        margin-bottom: 8px;
    }

    h1
    {
        border: 0;
        margin: 0;
        font-size: 16px;
    }

    p
    {
        padding: 0;
        margin: 0;
        margin-top: 0.5em;
    }

    .icon
    {
        flex: 0 0;
        padding-right: 8px;

        & > img
        {
            width: 32px;
        }
    }
    .left
    {
        flex: 3 3 100px;
        padding-right: 32px;
    }

    .right
    {
        flex: 2 2 100px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
}
</style>